
/**
 * 강의 콘텐츠 유형
 */
export type GetCourseDraftById200SectionsItemLecturesItemContentType = typeof GetCourseDraftById200SectionsItemLecturesItemContentType[keyof typeof GetCourseDraftById200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
